import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/1/thumb-landscape.jpg"

const Post1 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">LOUIS VUITTON／アルマPM／31 x22 x15cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          ルイ・ヴィトンのモノグラムは、ブランドにあまり興味がなくても「コレなら知っている！」という方も珍しくない圧倒的な認知度を誇ります。ヴィトンが築いてきた長い歴史と確かな物作りで、多くの方に愛されてきた証です。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>オンザゴー GM</h2>
          <p>世界中のファッショニスタが飛びついた新しいライン「オンザゴー」。見慣れたモノグラムですが、サイズが変わるだけでこんなに新鮮！？インパクトのあるデザインなのに機能性もバッチリなところが、流石のルイ・ヴィトンです。見る角度で異なる色やパターンに作り手のこだわりが感じられます。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/1.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/1/2.png" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/1/3.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">41x32x17cm(幅x高さxマチ)</span>        
        <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>スピーディ25</h2>
          <p>1930年に誕生したバッグ「エクスプレス」をアップデートさせたのがこの「スピーディー」。ナノ・25・30・40とサイズも選べますが、日常使いなら「スピーディ25」が程よいサイズ感ではないでしょうか。長財布やスマホ、化粧ポーチなどにプラスして本なんかも入りそう。コンパクトに見えますが、見た目以上の収納力です。モノグラムデビューに最適♪</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/4.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/1/5.png" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/1/6.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">25x20x14cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>ナノ・スピーディ</h2>
          <p>スピーディーをよりスタイリッシュに持ちたいならナノに決まり。トレンドに敏感なおしゃれな方に人気のサイズです。コロンと小さなボディを、斜めがけできるストラップでクロスボディにしても、ハンドルで持つのも可愛いですね！スマホや小さめのお財布など必要最低限の持ち物で身軽に出掛けましょう。実用性よりも見た目重視なあなたにおすすめ。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/7.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/8.png" alt="" />
            </figure>
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/9.jpg" alt="" />
            </figure>
        </div>
        <span className="text-center">15x11x8cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>ネヴァーフルMM</h2>
          <p>時代を超えて愛されるネヴァーフルMMは、オフィスカジュアルにもデニムなどの普段着にも合わせやすいトートタイプ。使い勝手は抜群です。間口が広くファスナーがないタイプなので、ポンポン荷物を入れられる気軽さがあります。細めのハンドルが肩にかけやすい秘密。日常使いにピッタリです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/10.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/11.jpg" alt="" />
            </figure>
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/12.jpg" alt="" />
            </figure>
        </div>
        <span className="text-center">32x29x17cm(幅x高さxマチ)</span>       
        <div className="text-max-width">
          <h2>ネオノエ</h2>
          <p>この形、いまやたくさんのブランドで見かけますが、ヴィトンではメゾンのアイコンバッグ。無駄なものがない洗練された飽きのこないデザインです。肩にかけてもクロスボディでも◎こなれ感のある大人のカジュアルスタイルに良く合いそう。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/13.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/14.png" alt="" />
            </figure>
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/15.jpg" alt="" />
            </figure>
        </div>
        <span className="text-center">25x25x17cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>ミュルティプリ・シテ</h2>
          <p>現在は公式では販売されていないミュルティプリ・シテ。四角いフォルムとたくさんのポケットが印象的です。かっちりしたフォルムが今の気分。ハンドルにある程度の長さがあるので、肩にもかけられるのが嬉しいポイントです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/16.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/17.png" alt="" />
            </figure>
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/18.jpg" alt="" />
            </figure>
        </div>
        <span className="text-center">36x26x11cm(幅x高さxマチ)</span>
        <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>パームスプリングスバックパックPM</h2>
          <p>モノグラムがアクティブなバックパックへ。厚みのあるストラップで快適に使えます。「楽チンなバックパックを使いたいけど、子供っぽくなりすぎるのは嫌！」そんなワガママも叶えてくれるアイテムです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/19.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/20.png" alt="" />
            </figure>
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/21.jpg" alt="" />
            </figure>
        </div>
        <span className="text-center">20x32x9cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>サックプラ</h2>
          <p>シンプルで男性にも利用者の多いサックプラ。マチがかなり薄めなので、使い方は限られますが、PCやA４サイズの書類もすっぽり収まります。トレンドのジャケットとパンツのセットアップといったモード感強めのスタイルやトラディショナルなスタイルなど、オシャレさんにオススメ。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/22.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/23.png" alt="" />
            </figure>
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/24.jpg" alt="" />
            </figure>
        </div>
        <span className="text-center">35x38x10cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>モンテーニュBB</h2>
          <p>女性らしいエレガントな装いにピッタリなモンテーニュBB。大き過ぎず、小さ過ぎずの絶妙なサイズ感で使い勝手の良さから人気のモデルです。バッグの中には複数の仕切りがあって機能的。お仕事にもプライベートにも連れていきたくなります。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/25.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/26.png" alt="" />
            </figure>
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/27.jpg" alt="" />
            </figure>
        </div>
        <span className="text-center">29x20x13cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>アルマPM</h2>
          <p>パリのアルマ橋からとったというその名の通り、アールデコ調のアーチを彷彿させるデザイン。タイムレスに愛されている名作です。エレガントなイメージですが、あえてカジュアルなスタイルと合わせてみるのも新鮮かもしれません。タイムレスなアイテムは、その時代ごとのファッションにしっくり馴染むから不思議。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/1/28.png" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/29.png" alt="" />
            </figure>
            <figure className="img-small">
            <StaticImage src="../../images/posts/1/30.jpg" alt="" />
            </figure>          
        </div>
        <span className="text-center">31x22x15cm(幅x高さxマチ)</span>
        <div className="text-two-cloumn">
          <h2>バッグ選びのポイント</h2>
          <p>たくさんあって、何を選べばいいかわからないことはありませんか？まずは、バッグを使いたいシーンを浮かべてみてはどうでしょう。お仕事ならA4サイズの書類が入る大きめサイズ、プライベート中心なら小さめのものを選ばれる方が多い傾向です。通勤バッグに大きさを求めないなら、ご自身のファッションのテイストにあったものを選ぶといいでしょう。フェミニンなテイストがお好みなら丸みがあるもの、キチンと感を出したいなら角張ったものなどバッグの形で印象も異なります。 あなたはどのタイプ？</p>
        </div>
        <div className="text-two-cloumn">
          <h2>モノグラムって<br className="pc"></br>レザーじゃないって知ってた？</h2>
          <p>モノグラムのハンドル部分などはレザーですが、ボディ部分は丈夫な綿素材にコーティング加工を施したPVC（塩化ビニル樹脂）で、正式名称は「トアル地」。「レザーではないの？」と思われる方もいるかもしれませんが、ここが使いやすさの秘密です。いわゆる合成皮革でありながら、シボ感のある型押し加工でレザーのような風合いに仕上げており安っぽさは皆無です。しかし、合成皮革のメリットである軽さはそのまま。憧れのブランドバッグを手にして、その重さに驚く方も少なくありません。レザーにはレザーにしかない魅力がありますが、「毎日のバッグには軽さも…」と感じている方にはモノグラムやダミエなどの合成皮革のシリーズから選ぶのが正解！</p>
        </div>
        <div className="text-two-cloumn">
          <h2>モノグラムは使い勝手がいい</h2>
          <p>デザインの幅が広く、扱いやすいルイ・ヴィトンのモノグラム。使い勝手の良さは世界中の愛用者の多さが証明しています。 たくさんありすぎて目移りしてしまう方もいるでしょう。ラクサスなら日常で使ってみて、気に入らなければ別のバッグに交換できます。自分にベストな大きさやデザインがきっと見つかるはずです。</p>
        </div>
        <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>                                                                                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post1

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 1}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
